import React, { ChangeEvent, useState } from "react";
import { Box, Card, Typography, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import AuthLayout from "./authLayout";

const AuthPasswordForGet: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(PATHS.AUTH_PASSWORD_MAIL_SEND);
  };

  return (
    <AuthLayout>
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 3,
          display: "flex",
          flexDirection: "column",
          maxWidth: "490px",
          width: "100%",
        }}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h5" align="center" sx={{ mb: 2 }}>
            パスワードの再設定
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{
              color: "rgba(9, 69, 88, 1)",
              fontSize: "14px",
              whiteSpace: "pre-line",
            }}
          >
            登録時に使用したメールアドレスを入力してください。{"\n"}
            パスワード再設定の手順を送信します
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box display="flex" flexDirection="column" gap={2} marginY={1}>
              <TextField
                fullWidth
                value={email}
                type="text"
                onChange={handleEmailChange}
                label="メールアドレス"
              />
              <Button
                sx={{ height: "42px" }}
                type="submit"
                variant="contained"
                fullWidth
              >
                送信
              </Button>
            </Box>
          </form>
        </Box>
      </Card>
    </AuthLayout>
  );
};

export default AuthPasswordForGet;
